import { LinkProps as RouterLinkProps, NavLink } from "react-router-dom";
import { Accordion, AccordionDetails, AccordionSummary, accordionSummaryClasses, Box, Link, LinkProps, styled } from "@mui/material";

type NavLinkProps = LinkProps &
  RouterLinkProps & {
    icon?: React.ReactNode;
    iconPosition?: "start" | "end";
  };
export const NavLinkWrapper = ({ children, icon, iconPosition = "start", ...rest }: NavLinkProps): JSX.Element => {
  return (
    <Link component={NavLink} {...rest} end>
      {icon && iconPosition === "start" && <span className="navigation-link-icon">{icon}</span>}
      <span className="navigation-link-label">{children}</span>
      {icon && iconPosition === "end" && <span className="navigation-link-icon">{icon}</span>}
    </Link>
  );
};

export const StyledNavigationLink = styled(NavLinkWrapper)`
  color: ${({ theme }) => theme.palette.text.primary};
  display: flex;
  font-size: ${({ theme }) => theme.typography.size.normal};

  padding: ${({ theme }) => theme.spacing(0.5, 0.5, 0.5, 1)};
  align-items: center;
  margin: ${({ theme }) => theme.spacing(0.5, 0)};
  border-radius: ${({ theme }) => theme.custom.shape.borderRadius.medium};

  & .navigation-link-icon {
    display: inline-flex;
    & svg {
      font-size: ${({ theme }) => theme.typography.size.medium};
    }
  }
  & .navigation-link-label {
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    &:not(:first-of-type) {
      margin-left: ${({ theme }) => theme.spacing(1)};
    }
    &:first-of-type {
      margin-right: ${({ theme }) => theme.spacing(1)};
    }
  }

  &.see-all {
    color: ${({ theme }) => theme.palette.biarri.secondary.activeBlue};
    font-size: ${({ theme }) => theme.typography.size.small};

    .navigation-link-icon {
      & svg {
        font-size: ${({ theme }) => theme.typography.size.normal};
      }
    }
  }

  &.active,
  &:hover,
  &:focus,
  &.active:hover,
  &.active:focus {
    &,
    &.see-all .navigation-link-icon svg {
      color: ${({ theme }) => theme.palette.text.primary};
    }
    .navigation-link-label {
      text-decoration: underline;
    }
  }

  .icon {
    display: inline-flex;
    color: rgba(0, 0, 0, 0.25);
    padding-right: ${({ theme }) => theme.spacing(1.5)};
  }

  &.active .icon {
    color: ${({ theme }) => theme.palette.biarri.primary.red};
  }
`;

export const NavigationAccordion = styled(Accordion)`
  box-shadow: none;
  background-color: transparent;

  &::before {
    display: none;
  }
`;

export const NavigationAccordionSummary = styled(AccordionSummary)`
  justify-content: start;
  min-height: 0;
  font-size: ${({ theme }) => theme.typography.size.small};
  padding-left: 0;

  .${accordionSummaryClasses.content} {
    flex-grow: 0;
    margin: ${({ theme }) => theme.spacing(1, 0)};
  }
  .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded} {
    transform: rotate(90deg);
  }
`;

export const NavigationAccordionDetails = styled(AccordionDetails)`
  padding: ${({ theme }) => theme.spacing(0, 1, 0, 0)};
`;

export const NoItemsMessage = styled(Box)`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: ${({ theme }) => theme.typography.size.normal};
  padding: ${({ theme }) => theme.spacing(1, 2)};
`;
